import { render, staticRenderFns } from "./ClientesAdmin.vue?vue&type=template&id=ae7f38fc&scoped=true"
import script from "./ClientesAdmin.vue?vue&type=script&lang=js"
export * from "./ClientesAdmin.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ClientesAdmin.vue?vue&type=style&index=1&id=ae7f38fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7f38fc",
  null
  
)

export default component.exports